// 将文件路径转为blob
function getBlob (url) {
	return new Promise(resolve => {
		const xhr = new XMLHttpRequest()
		// 避免 200 from disk cache
		xhr.open('GET', url, true)
		xhr.responseType = 'blob'
		xhr.onload = () => {
			if (xhr.status === 200) {
				resolve(xhr.response)
			}
		}
		xhr.send()
	})
}
function saveAs (blob, filename) {
	if (window.navigator.msSaveOrOpenBlob) {
		navigator.msSaveBlob(blob, filename)
	} else {
		const anchor = document.createElement('a')
		const body = document.querySelector('body')
		anchor.href = window.URL.createObjectURL(blob)
		anchor.download = filename
		anchor.style.display = 'none'
		body.appendChild(anchor)
		anchor.click()
		body.removeChild(anchor)
		window.URL.revokeObjectURL(anchor.href)
	}
}
export async function download (path,name,fileName) {
  console.log('path,name',path,name);
	const str=name?name:fileName
	const blob = await getBlob(path)
	saveAs(blob, str)
	
}